import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55263c34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subpage" }
const _hoisted_2 = { key: 2 }

import TabMenu from '@/common/components/snedson-material-components/tab-menu/tab-menu.vue';
import { ITabMenuProps } from '@/common/components/snedson-material-components/tab-menu/tab-menu.types';
import { reactive } from 'vue';
import { NotificationSubpage } from './NotificationPage.types';
import AnnouncementsSubpage from '@/views/pages/CommonPages/AnnouncementsSubpage/AnnouncementsSubpage.vue';
import NotificationsFromTeachersSubpage from './Subpages/NotificationsFromTeachersSubpage/NotificationsFromTeachersSubpage.vue';
import router from '@/router';
import { HandleAnimation } from '@/services/animation-service';
import { animationState } from '@/services/animation-service/animation-state.ts';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationPage',
  setup(__props) {

const state = reactive<ITabMenuProps>({
    tabs: [
        { id: NotificationSubpage.Announcements, title: 'Школьные объявления' },
        {
            id: NotificationSubpage.NotificationsFromTeachers,
            title: 'Уведомления от учителей',
        },
    ],
    selectedTabItemId: NotificationSubpage.Announcements,
});

const selectTab = (tabId: NotificationSubpage) => {
    animationState.flow = HandleAnimation('horizontal', state.selectedTabItemId, tabId);
    state.selectedTabItemId = tabId;

    if (tabId == NotificationSubpage.Announcements) {
        router.push({ name: 'sn.student.notifications.announces' });
    } else {
        router.push({ name: 'sn.student.notifications.fromTeachers' });
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(TabMenu, {
      props: state,
      onChange: selectTab
    }, null, 8, ["props"]),
    _createElementVNode("div", _hoisted_1, [
      (
                    state.selectedTabItemId ===
                    _unref(NotificationSubpage).Announcements
                )
        ? (_openBlock(), _createBlock(AnnouncementsSubpage, { key: 0 }))
        : (
                    state.selectedTabItemId ===
                    _unref(NotificationSubpage).NotificationsFromTeachers
                )
          ? (_openBlock(), _createBlock(NotificationsFromTeachersSubpage, { key: 1 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, "error"))
    ])
  ]))
}
}

})